import { getInputRange, isValidInputValue } from '@cascade/react/experiences';
import { useI18n } from '@cascade/react/i18n';
import { iconTypes, Input, TextArea } from '@cascade/ui-library';
import { useState } from 'react';
import { describeNumberRange } from './InputWidget.helpers.ts';
import type { TInputWidgetProps } from './InputWidget.types.ts';

export const InputWidget = ({
  widget,
  label,
  value = '',
  isDisabled,
  onChange,
}: TInputWidgetProps) => {
  const isNumber = widget.input_type === 'number';
  const iconType = iconTypes.find((type) => type === widget.input_icon);
  const range = getInputRange(widget);

  const [invalidText, setInvalidText] = useState<string>();
  const { locale, translate } = useI18n();

  const draftText = value ? undefined : invalidText;
  const feedbackText =
    draftText === undefined
      ? undefined
      : describeNumberRange(translate, range, locale);

  const changeText = (text: string) => {
    const isAccepted = isValidInputValue(widget, text);

    setInvalidText(isAccepted ? undefined : text);
    onChange(isAccepted ? text : '');
  };

  if (widget.input_type === 'textarea') {
    return (
      <TextArea
        label={label}
        labelDisplay='hidden'
        placeholder={widget.placeholder}
        value={value}
        disabled={isDisabled}
        onChange={onChange}
      />
    );
  }

  return (
    <Input
      label={label}
      labelDisplay='hidden'
      type={isNumber ? 'number' : 'text'}
      min={range.min}
      max={range.max}
      placeholder={widget.placeholder}
      iconType={iconType}
      suffix={widget.input_suffix}
      value={draftText ?? value}
      disabled={isDisabled}
      feedbackLevel={feedbackText ? 'danger' : undefined}
      feedbackText={feedbackText}
      onChange={changeText}
    />
  );
};
